"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordValidator = exports.Errors = void 0;
exports.Errors = {
    required: true,
    notHasCapital: true,
    notHasLow: true,
    notHasNumber: true,
    notHasSymbol: true,
    min: true,
};
class PasswordValidator {
    constructor(conf) {
        this.conf = conf;
    }
    validate(password) {
        PasswordValidator.validatePassword(password, this.conf);
    }
    static validatePassword(password, configuration) {
        const errors = exports.Errors;
        if (password == null || password === '') {
            errors.required = true;
            errors.notHasLow = true;
            errors.notHasCapital = true;
            errors.notHasNumber = true;
            errors.notHasSymbol = true;
            errors.min = true;
        }
        else {
            errors.required = false;
            const hasCapital = /[A-ZÖÜÄ]/.test(password);
            const hasLow = /[a-züäöß]/.test(password);
            const hasNumber = /[0-9]/.test(password);
            const hasSymbol = /[^a-zA-Z0-9ÖÜÄöüäß]/.test(password);
            errors.notHasCapital = configuration.requireCapital ? !hasCapital : false;
            errors.notHasLow = configuration.requireLow ? !hasLow : false;
            errors.notHasNumber = configuration.requireNumber ? !hasNumber : false;
            errors.notHasSymbol = configuration.requireSymbol ? !hasSymbol : false;
            if (password.length < configuration.minLength) {
                errors.min = true;
            }
            else {
                errors.min = false;
            }
        }
        return errors;
    }
}
exports.PasswordValidator = PasswordValidator;
